import { render } from "./UserListTableHeader.vue?vue&type=template&id=0c989578&scoped=true&ts=true"
import script from "./UserListTableHeader.vue?vue&type=script&lang=ts"
export * from "./UserListTableHeader.vue?vue&type=script&lang=ts"

import "./UserListTableHeader.vue?vue&type=style&index=0&id=0c989578&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c989578"]])

export default __exports__